export default function (doc, filename, url) {
    var fileLink = doc.createElement('a');
    fileLink.href = url;
    fileLink.setAttribute('download', filename);
    fileLink.setAttribute('target', '_blank');
    doc.body.appendChild(fileLink);
    fileLink.click();        
}
